export interface UnitInput {
  unit_number?: unknown;
}

export interface PersonInput {
  first_name?: unknown;
  last_name?: unknown;
  email?: unknown;
}

export const validateUnitInput = (input: UnitInput): Record<string, string> => {
  const errors: Record<string, string> = {};
  if (!String(input.unit_number ?? '').trim()) errors.unit_number = 'Required';
  return errors;
};

export const validatePersonInput = (input: PersonInput): Record<string, string> => {
  const errors: Record<string, string> = {};
  if (!String(input.first_name ?? '').trim()) errors.first_name = 'Required';
  if (!String(input.last_name ?? '').trim()) errors.last_name = 'Required';
  const email = String(input.email ?? '').trim();
  if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.email = 'Enter a valid email address.';
  }
  return errors;
};
